"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportAbstract = void 0;
var helper_1 = require("../../core/helper");
var common_impl_1 = __importDefault(require("../atomic-request/request-encrypt/common-impl"));
var common_impl_2 = __importDefault(require("../atomic-request/request-encrypt-v5/common-impl"));
var helper_factory_1 = __importDefault(require("../helper/helper-factory"));
var ReportAbstract = /** @class */ (function () {
    function ReportAbstract() {
    }
    ReportAbstract.prototype.reportRequest = function (data, path) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, headers, baseUrl, params, headersV3, mergedHeaders, result, error_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = data || {}, _b = _a.headers, headers = _b === void 0 ? {} : _b, baseUrl = _a.baseUrl, params = _a.params;
                        if (!path.startsWith('http') && !baseUrl) {
                            baseUrl = (0, helper_1.getBaseUrl)();
                        }
                        headersV3 = helper_factory_1.default.getAiServerHeaders();
                        mergedHeaders = helper_factory_1.default.getObjKeysMerged(headersV3, headers);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, common_impl_1.default.request({
                                url: "".concat(baseUrl || '').concat(path),
                                method: 'POST',
                                headers: __assign(__assign({}, mergedHeaders), { 'Content-Type': 'application/json' }),
                                data: params
                            })];
                    case 2:
                        result = _c.sent();
                        console.log('ai sdk common report reportRequest: ', result);
                        return [2 /*return*/, result];
                    case 3:
                        error_1 = _c.sent();
                        console.log('ai sdk common report reportRequest error: ', error_1);
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ReportAbstract.prototype.reportRequestV5 = function (data, path) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, headers, baseUrl, params, timeout, headersV5, mergedHeaders, result, error_2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = data || {}, _b = _a.headers, headers = _b === void 0 ? {} : _b, baseUrl = _a.baseUrl, params = _a.params, timeout = _a.timeout;
                        if (!path.startsWith('http') && !baseUrl) {
                            baseUrl = (0, helper_1.getBaseUrlV5)();
                        }
                        headersV5 = helper_factory_1.default.getAiServerHeadersV5();
                        mergedHeaders = helper_factory_1.default.getObjKeysMerged(headersV5, headers);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, common_impl_2.default.request({
                                url: "".concat(baseUrl || '').concat(path),
                                method: 'POST',
                                timeout: timeout || null,
                                headers: __assign(__assign({}, mergedHeaders), { 'Content-Type': 'application/json' }),
                                data: params
                            })];
                    case 2:
                        result = _c.sent();
                        console.log('ai sdk common report reportRequest: ', result);
                        return [2 /*return*/, result];
                    case 3:
                        error_2 = _c.sent();
                        console.log('ai sdk common report reportRequest error: ', error_2);
                        throw error_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return ReportAbstract;
}());
exports.ReportAbstract = ReportAbstract;
